<template>
  <div class="payment-info">
    <div class="total-price">
      <span>{{ $t('商品总价') }}</span>
      <span class="total-price-display">
        <span class="price-symbol">￥</span>
        <span>{{ menuStandardPriceDisplay }}</span>
      </span>
    </div>
    <es-collapse class="discount-collapse" v-model="couponExpanded" accordion>
      <es-collapse-item :class="{ 'discount-add': hideCouponSelection }" name="coupon" :disabled="hideCouponSelection">
        <template slot="title">
          <div class="discount">
            <span>{{ $t('优惠') }}</span>
            <template v-if="promotionDisplay || couponList?.length">
              <es-button
                v-if="showInputCouponBtn"
                class="discount-btn"
                variant="text"
                theme="primary"
                size="mini"
                @click="showCouponDialog"
                :disabled="waitPay">
                {{ $t('输入优惠券码') }}
              </es-button>
              <div v-else class="discount-btn">
                <span class="discont-money">
                  <span class="discont-symbol">￥</span>
                  <span>{{ discountedMoney }}</span>
                </span>
              </div>
            </template>
            <span class="no-discount" v-else>{{ $t('暂无优惠') }}</span>
          </div>
        </template>
        <div class="check-pannel">
          <es-radio-group :value="couponsNumber" layout="vertical" @input="handleCouponChange" :disabled="waitPay">
            <es-radio :label="item.activeNo" class="payment-method-item" v-for="(item, index) in couponList"
              :key="index">
              <span>{{ item.name }}</span>
            </es-radio>
            <es-radio :label="null" class="payment-method-item" v-if="!hideDontUseCoupon">
              <span>{{ $t('不使用优惠') }}</span>
            </es-radio>
          </es-radio-group>
          <div class="exchange-coupon" v-if="promotionDisplay">
            <img src="@/assets/icons/couponIcon.svg" :alt="$t('兑换优惠券')" />
            <es-button class="replace-btn" type="text" theme="primary" @click="showCouponDialog"
              :disabled="waitPay">
              {{ $t('兑换优惠券') }}
            </es-button>
          </div>
        </div>
      </es-collapse-item>
    </es-collapse>
    <div class="check-pannel payment-methods">
      <es-radio-group :value="paymentMethod" layout="vertical" @input="handlePaymentMethodChange" :disabled="isInvalid">
        <template v-for="method in paymentMethods">
          <es-radio
            :label="method.value"
            :key="method.value"
            class="payment-method-item"
            v-if="method.value !== PAYMENT_METHOD.BALANCE || hasBalance"
            :disabled="method.value === PAYMENT_METHOD.BALANCE && insufficientBalance">
            <img :src="method.icon" :alt="method.label" />
            <span>{{ method.label }}&nbsp;&nbsp;{{ method.value === 'balance' ? `￥${myWallet}` : '' }}</span>
          </es-radio>
        </template>
      </es-radio-group>
    </div>
    <div class="pay-footer">
      <div class="actual-payment">
        <span>{{ $t('实付款：') }}</span>
        <span>
          <span class="actual-payment-unit">￥</span>
          <span>{{ payAmountDisplay }}</span>
        </span>
      </div>
      <div class="confirm-agree">
        <es-tooltip
          effect="dark"
          :content="$t('请先阅读并同意协议')"
          placement="top-start"
          manual
          :value="Boolean(!protocolChecked && submitCount)"
          popper-class="protocol-popper"
          :offset="-80">
          <es-checkbox :value="protocolChecked" @change="handleProtocolChange" :disabled="isInvalid">
            {{ $t('我已阅读并同意') }}
          </es-checkbox>
        </es-tooltip>
        <es-button class="confirm-agree-btn" variant="text" theme="primary" @click="viewCert">{{ $t('服务协议') }}</es-button>
      </div>
      <es-button class="pay-btn" type="primary" @click="submitPayment" size="large" :loading="paying" :disabled="isInvalid">
        {{ $t('立即支付') }}
      </es-button>
    </div>
    <ExchangedCoupon :visible="checkCoupons" :confirmExchange="confirmExchange" @close="closeExchanged" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orderSourceMap } from '@esign/esign-client-jssdk'
import tsignDataTrack from '@tsign/tsigndata-sdk-js'
import { PAYMENT_METHOD } from '@/consts/payment'
import ExchangedCoupon from './ExchangedCoupon.vue'
export default {
  name: 'PaymentInfo',
  components: {
    ExchangedCoupon,
  },
  props: {
    payAmountDisplay: {
      type: [Number, String],
      default: '0.00',
    },
    menuTotalPrice: {
      type: [Number, String],
      default: '0.00',
    },
    promotionDisplay: {
      type: Boolean,
      default: false,
    },
    discounted: {
      type: Number,
      default: 0,
    },
    couponList: {
      type: Array,
      default: () => [],
    },
    coupenName: {
      type: String,
      default: '',
    },
    checkCoupons: {
      type: Boolean,
      default: false,
    },
    // 优惠券选择类型
    couponType: {
      type: Number,
      default: 0,
    },
    paying: {
      type: Boolean,
      default: false,
    },
    menuStandardPriceDisplay: {
      type: [Number, String],
      default: '0.00',
    },
    getCoupons: {
      type: Function,
      default: () => {},
    },
    waitPay: {
      type: Boolean,
      default: false,
    },
    couponsNumber: {
      type: [Number, String, null],
      default: null,
    },
    paymentMethod: {
      type: String,
      default: PAYMENT_METHOD.ALIPAY,
    },
    orderInfo: {
      type: Object,
      default: () => ({}),
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    payAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      PAYMENT_METHOD,
      paymentMethods: [
        {
          icon: require('@/assets/icons/alipay.svg'),
          label: this.$t('支付宝'),
          value: PAYMENT_METHOD.ALIPAY,
        },
        {
          icon: require('@/assets/icons/wechat.svg'),
          label: this.$t('微信支付'),
          value: PAYMENT_METHOD.WECHAT,
        },
        {
          icon: require('@/assets/icons/bank.svg'),
          label: this.$t('银行转账（对公支付）'),
          value: PAYMENT_METHOD.BANK,
        },
        {
          icon: require('@/assets/icons/balance.svg'),
          label: this.$t('余额'),
          value: PAYMENT_METHOD.BALANCE,
        },
      ],
      chouponExchanged: false,
      couponExpanded: '',
      submitCount: 0, // 提交次数
      balance: 0, // 用户余额
      myWallet: 0, // 钱包余额
      protocolChecked: false, // 协议是否勾选
      sourceChannel: Number(sessionStorage.getItem('source_channel')) || 0,
      // 融合场景-指定主体
      epBindOrgInfo: {
        epBindOrg: false, // 融合场景-指定主体
        epBindOrgId: '', // 融合场景-指定主体orgId
        epBindOrgName: '', // 融合场景-指定主体orgName
      }, // 融合场景-指定主体orgInfo
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isPartner: state => state.isPartner,
      isOrg: state => state.isOrg,
      tsignData: state => state.tsignData,
    }),
    discountedMoney() {
      return this.couponType === 1 ? this.discounted?.toFixed(2) : '0.00'
    },
    showCoupouExpand() {
      return this.chouponExchanged || this.coupenName
    },
    showInputCouponBtn() {
      return !this.showCoupouExpand && !this.couponList?.length
    },
    // promotionDisplay：1-下单直接优惠，2-输入优惠码后优惠，存在下单直接优惠的优惠券，则不显示不使用优惠券选项
    hideDontUseCoupon() {
      return Boolean(this.couponList?.find(item => item.promotionDisplay === 1))
    },
    // 是否显示优惠券选择下拉
    hideCouponSelection() {
      return !this.couponList?.length || !this.promotionDisplay
    },
    // 余额不足
    insufficientBalance() {
      return this.myWallet < this.payAmount
    },
    // 是否可使用余额支付
    hasBalance() {
      return Boolean(this.userInfo.realName && this.myWallet > 0 && this.userInfo.isAdmin && !this.isPartner)
    },
  },
  watch: {
    payAmount: {
      handler(val) {
        // 余额不足且选择余额支付时要切换成其他支付
        if (this.insufficientBalance && this.paymentMethod === PAYMENT_METHOD.BALANCE) {
          this.handlePaymentMethodChange(PAYMENT_METHOD.ALIPAY)
        }
      },
    },
  },
  created() {
    this.initBalancePay()
    if (this.waitPay) {
      this.reportSourceChannel('order_pendingPayment')
    }
    // 融合场景购买页链接指定了企业organ，当打开链接的用户并不在该主体下，需要拦截
    const { organ = '', epBindOrg = false } = this.$route.query
    if (JSON.parse(epBindOrg) && organ && this.userInfo.orgId !== organ) {
      this.epBindOrgInfo = {
        epBindOrg: true,
        epBindOrgId: organ,
        epBindOrgName: this.userInfo.orgName,
      }
      this.$ajax(this.$url.getSummaryByOrgId(organ), {}, false).then(res => {
        this.epBindOrgInfo.epBindOrgName = res?.data?.name
      })
    }
  },
  methods: {
    // 初始化余额支付
    async initBalancePay() {
      if (this.userInfo.realName && this.userInfo.isAdmin) {
        const tempBalance = await this.getBalance()
        this.balance = tempBalance.data.balance || 0
      }
    },
    // 获取用户余额
    async getBalance() {
      const params = {}

      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getAccountWalletAmount(), params, false)
          .then(res => {
            const walletType = res.data.walletResultList.filter(item => item.walletType === 'DEFAULT')
            walletType.length > 0 && (this.myWallet = walletType[0].balance)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 支付方式选择
    handlePaymentMethodChange(val) {
      this.$emit('update:paymentMethod', val)
    },
    // 协议勾选
    handleProtocolChange(val) {
      this.protocolChecked = val
    },
    handleCouponChange(val) {
      const coupon = this.couponList.find(item => item.activeNo === val) || null
      // 0 不使用优惠 1 使用优惠, 第二个参数是优惠券码或者不使用优惠券选项，优惠券码为使用优惠券转化为类型1，不使用优惠券我i类型0
      this.$emit('couponChange', Number(Boolean(val)), coupon)
    },
    showCouponDialog() {
      this.$emit('update:checkCoupons', true)
    },
    closeExchanged() {
      this.$emit('update:checkCoupons', false)
    },
    reportSourceChannel(type) {
      const personOid = localStorage.getItem('ouid')
      const personGid = localStorage.getItem('guid')
      const patmentMethodName = this.paymentMethods?.find(item => item.value === this.paymentMethod)?.label
      const data = {
        commodity_number: this.orderInfo?.totalNum,
        commodity_name: this.orderInfo?.commodityName,
        commodity_id: this.orderInfo?.commodityId,
        user_type: this.isOrg ? '企业' : '个人',
        oid: this.isOrg ? this.userInfo?.orgId : personOid,
        gid: this.isOrg ? this.userInfo?.gid : personGid,
        pay_amount: this.payAmountDisplay,
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap?.[this.sourceChannel] || 'other',
        order_id: this.orderInfo?.showId,
        payment_method: patmentMethodName,
      }
      tsignDataTrack.track(type, data)
    },
    submitPayment() {
      // 融合场景购买页链接指定了企业organ，当打开链接的用户并不在该主体下，需要拦截
      if (this.epBindOrgInfo.epBindOrg && this.epBindOrgInfo.epBindOrgId && this.userInfo.orgId !== this.epBindOrgInfo.epBindOrgId) {
        return this.$message.warning(
          this.$t('当前登录的企业和购买链接所属的企业（{epBindOrgName}）不一致，请选择正确企业空间或者重新登录', {
            epBindOrgName: this.epBindOrgInfo.epBindOrgName,
          })
        )
      }

      this.submitCount++
      if (!this.protocolChecked) {
        return false
      }
      // 提交支付逻辑
      this.$emit('submitPayment')
      this.reportSourceChannel('to_pay_order')
    },
    viewCert() {
      window.open('https://asset.esign.cn/template/agreement.html', '_blank')
    },
    async confirmExchange(couponsNumber) {
      const hasCoupon = this.couponList.find(item => item.activeNo === couponsNumber)
      if (hasCoupon) return this.$message.warning(this.$t('优惠券已存在'))

      try {
        await this.getCoupons(couponsNumber, 1)
        this.chouponExchanged = true
        this.couponExpanded = 'coupon'
      } catch (error) {
        console.log('获取优惠券失败：', error)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.payment-info {
  padding: 24px;
  background: #fff;
  border-radius: 8px;

  .total-price {
    display: flex;
    justify-content: space-between;

    span {
      line-height: 22px;

      &:first-child {
        font-weight: 400;
        font-size: 14px;
        color: #666;
      }
    }
    .total-price-display {
      font-weight: 600;
      font-size: 16px;
      color: #333;
      .price-symbol {
        font-size: 12px;
        margin-right: 2px;
        font-weight: 600;
        color: #333;
      }
    }
  }

  /deep/.discount-collapse {
    border: none;
    margin-top: 12px;

    .discount-add {
      .es-collapse-item__arrow {
        display: none;
      }
    }

    .es-collapse-item__header {
      border: none;
      height: unset;

      .es-collapse-item__arrow {
        margin-left: 2px;
        margin-right: 0;
        color: #ff3b30;
        transform: rotate(90deg);
      }

      .es-collapse-item__arrow.is-active {
        transform: rotate(-90deg);
      }
    }

    .es-collapse-item__wrap {
      border: none;
    }

    .es-collapse-item__content {
      padding-bottom: 0;
    }
  }

  .discount {
    display: flex;
    justify-content: space-between;
    // margin-top: 12px;
    width: 100%;
    line-height: 20px;
    height: 20px;
    span {
      font-weight: 400;
      font-size: 14px;
      color: #666;
    }

    .discount-btn {
      font-size: 12px;
      line-height: 20px;
      .discont-money {
        span {
          color: #ff3b30;
          font-weight: 600;
          font-size: 16px;
        }
        .discont-symbol {
          font-size: 12px;
          margin-right: 2px;
          font-weight: 600;
        }
      }
      .no-discount {
        font-weight: 600;
        font-size: 14px;
        color: #bfbfbf;
      }
    }
  }

  .check-pannel {
    background: #f7f8fa;
    padding: 12px;
    margin-top: 24px;

    .payment-method-item {
      display: flex;
      align-items: center;
      margin-top: 10px !important;

      &:first-child {
        margin-top: 0 !important;
      }

      /deep/ .es-radio__label {
        display: flex;
        align-items: center;
        padding-left: 12px;
      }

      img {
        width: 16px;
      }

      span {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #333333;
        margin-left: 8px;
      }
    }

    .exchange-coupon {
      margin-top: 10px;
      padding-top: 10px;
      display: flex;
      align-items: center;
      border-top: 1px solid #f5f5f5;

      img {
        width: 16px;
        margin-right: 10px;
      }
    }

    .replace-btn {
      margin-left: 8px;
    }
  }

  .pay-footer {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #f5f5f5;

    .actual-payment {
      display: flex;
      align-items: flex-end;
      span {
        font-weight: 400;
        font-size: 12px;
        line-height: 28px;
        color: #000;

        &:last-child {
          font-weight: 600;
          font-size: 20px;
          color: #ff3b30;
        }
        .actual-payment-unit {
          color: #ff3b30;
          font-size: 12px;
        }
      }
    }

    .confirm-agree {
      margin-top: 12px;
      display: flex;
      align-items: center;

      .confirm-agree-btn {
        margin-left: 4px;
      }
    }
    .pay-btn {
      margin-top: 12px;
      width: 100%;
    }
  }
}
</style>
<style lang="less">
.protocol-popper {
  margin-left: -86px;
}
</style>
